export const makeImagesFitWrapper = (html) => {
    return html.replace(
        `<img style="`,
        `<img style="max-width: 100% !important; height: auto;`
    );
};
